export default __webpack_public_path__ + "static/media/echo3d.5e6688a1.png";